import { Tooltip } from 'shared/ui/Tooltip';
import { formatPrice } from 'shared/lib/formatting';

import type { BidTiersModel } from '../../@x';

import { BidTiersContent } from './BidTiersContent';

interface BidTiersProps {
  className?: string;
  bid: number | null;
  bidTiers: BidTiersModel | null;
  serviceName: string;
}

export function BidTiers({ className, bid, bidTiers, serviceName }: BidTiersProps) {
  if (bid) {
    return <div className={`${className} font-medium`}>{formatPrice(bid)}</div>;
  }

  const primaryBid = bidTiers?.[0];
  const restBids = bidTiers?.slice(1);

  return (
    <>
      {primaryBid && (
        <div className={`flex items-center gap-1 ${className}`}>
          <span className="font-medium">{formatPrice(primaryBid.bid)}</span>
          {restBids && restBids.length > 0 && (
            <Tooltip
              placement="top"
              widthClass="max-w-auto"
              content={
                <BidTiersContent
                  serviceName={serviceName}
                  bidTiers={bidTiers}
                  className="w-[225px]"
                />
              }
            >
              <span className="cursor-pointer rounded-sm bg-light-blue-50 px-[6px] py-[5px] text-[11px] font-medium text-light-blue-700">
                +{restBids.length}
              </span>
            </Tooltip>
          )}
        </div>
      )}
    </>
  );
}
